export default __webpack_public_path__ + "static/media/gargraFrostFireRidge.dd5278b1.jpg";